import React, { Component } from 'react';
import Tablec from 'components/Tablec';
import { observer } from 'mobx-react';
import dshStore from '../request/model';
import { getSensor } from '../request/dao';
import './index.styl';

const clzpre = 'dsh-sensor';
const columns = [
    {
        name: '名称',
        key: 'name'
    },
    {
        name: '温度',
        key: 'temperature'
    },
    {
        name: '外接温度1',
        key: 'outSideTemperature1'
    },
    {
        name: '湿度',
        key: 'humidity'
    },
    {
        name: '状态',
        key: 'status',
        render: v => {
            let clz = 'normal';
            let text = '正常';
            switch (v) {
                case 3:
                    clz = 'error';
                    text = '报警';
                    break;
                case 2:
                    clz = 'warning';
                    text = '警告';
                    break;
                default:
            }
            return <span className={`${clzpre}-status ${clz}`}>{text}</span>;
        }
    }
];

@observer
class Sensor extends Component {
    constructor(props) {
        super(props);
        getSensor();
    }

    render() {
        const { sensors } = this.props.dshStore;
        const props = { columns, data: sensors };
        return (
            <div className={`${clzpre} dsh-box`}>
                <h3>传感器信息</h3>
                <div className={`${clzpre}-table`}>
                    <Tablec {...props} />
                </div>
            </div>
        );
    }
}

export default props => <Sensor {...props} dshStore={dshStore} />;
